export type PathParamsType = string | RegExp | (string | RegExp)[];
